import axios from 'axios'

const API_URL = 'https://testiventpay.hisiastudio.com/testiventpay/api/'

const createClient = async (data) => {
    let paysSlug = data.payss
    let responsePays = await axios.get(`${API_URL}pays/${paysSlug}/`)
    if(responsePays.status === 200){
        let paysId = responsePays.data.id;
        const clientData = {
            mail: data.email,
            numero: data.telephone,
            pays: paysId
        }
        const response = await axios.post(`${API_URL}client/`, clientData)
        if(response.status === 201){
            return response.data
        }else{
            return {msg: "Une erreur est survenue", status: response.status}
        }
    }else{
        return {msg: "Une erreur est survenue", status: responsePays.status}
    }
}

const  getMoyenPaiementParPays = async (data) => {
  
    const response = await axios.get(API_URL + "moyendepaiement/?slug=" + data)
    if(response.status === 200){
        return response.data
    }else{
        return {msg: "Une erreur est survenue", status: response.status}
    }
}

const payementCreate = async (data) => {
    
    console.log(data)
    const response = await axios.post(API_URL + "paiement/", data)
   
    if(response.status === 201){
        return response.data
    }else{
        return {msg: "Une erreur est survenue", status: response.status}
    }
}

const payementService = {
    createClient,
    getMoyenPaiementParPays,
    payementCreate
}

export default payementService